import React from "react";
import { useHistory } from "react-router-dom";
import Navbar from "../Navbar";
import HeroSection from "../HeroSection";
import FeaturesSection from "../FeaturesSection";
import CodeExampleSection from "../CodeExampleSection";
import Footer from "../Footer";

// 导入组件样式
import "../Navbar/style.less";
import "../HeroSection/style.less";
import "../FeaturesSection/style.less";
import "../CodeExampleSection/style.less";
import "../Footer/style.less";

// 主页布局组件
const HomeLayout: React.FC = () => {
	const history = useHistory();

	const handleLoginClick = () => {
		history.push("/login");
	};

	return (
		<div className="app-layout">
			{/* 导航栏 */}
			<Navbar onLoginClick={handleLoginClick} />

			{/* 主要内容 */}
			<main style={{ flex: 1 }}>
				<HeroSection onLoginClick={handleLoginClick} />
				<FeaturesSection />
				<CodeExampleSection />
			</main>

			{/* 页脚 */}
			<Footer />
		</div>
	);
};

export default HomeLayout;
